export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  MARKETPLACE = 'ROLE_MARKETPLACE',
  POS_LAAS = 'ROLE_POS_LAAS',
  POS_SYSTEM = 'ROLE_POS_SYSTEM',
}
